import { QR_PLACEHOLDER_PATTERN } from "./signup.constants.ts";

/**
 * A stand-in for the scan code.
 *
 * Decorative, and deliberately not scannable: there is no identity provider
 * wired up yet, so a real QR would encode a link to nothing. It is marked
 * aria-hidden and the panel says in words that the scan is not live, because a
 * placeholder that looks functional is worse than an obvious one — someone
 * would point a phone at it and conclude the flow is broken.
 *
 * Drawn from a fixed pattern rather than an encoder so it costs no dependency;
 * swap the whole component for the provider's rendered code when one lands.
 */
export function QrPlaceholder() {
  const size = QR_PLACEHOLDER_PATTERN.length;

  return (
    <svg
      className="signup__qr"
      viewBox={`0 0 ${size} ${size}`}
      aria-hidden="true"
      focusable="false"
    >
      <rect width={size} height={size} fill="var(--surface)" />
      {QR_PLACEHOLDER_PATTERN.flatMap((row, y) =>
        [...row].map((cell, x) =>
          cell === "1" ? (
            <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="var(--ink)" />
          ) : null,
        ),
      )}
    </svg>
  );
}
